<script setup lang="ts">
import { ref } from 'vue'

import { Button, Popover } from '@collector/shared-ui'

type Props = {
  text: string
}
defineProps<Props>()

type Emits = {
  confirm: [void]
  cancel: [void]
}
const emit = defineEmits<Emits>()

// state
const isOpen = ref(false)

// methods
function confirm(): void {
  close()
  emit('confirm')
}
function cancel(): void {
  close()
  emit('cancel')
}
function close(): void {
  isOpen.value = false
}
</script>

<template>
  <Popover
    v-model="isOpen"
    :withCloseIcon="false"
    :content="{ align: 'center' }"
    :trigger="{ asChild: true }"
  >
    <template #trigger>
      <slot />
    </template>

    <template #content>
      <div class="max-w-64 font-bold">
        <div class="text-neutral-dark-0 pb-2 text-center">
          {{ text }}
        </div>
        <div class="flex gap-x-4">
          <Button
            class="text-neutral-dark-0 border-neutral-dark-0 hover:border-neutral-dark-2 hover:bg-neutral-light-4 px-4"
            size="sm"
            width="full"
            @click="cancel()"
          >
            No
          </Button>
          <Button
            class="text-neutral-light-10 bg-success-2 border-success-2 hover:border-success-4 hover:bg-success-4 px-4"
            size="sm"
            width="full"
            @click="confirm()"
          >
            Yes
          </Button>
        </div>
      </div>
    </template>
  </Popover>
</template>
